<div class="row m-0">
    <div class="col-sm-12 nav d-flex justify-content-between">
        <a href="javascript:void(0)" class="firstAgenda"><i class="fa fa-caret-left" aria-hidden="true"></i><i
                class="fa fa-caret-left" aria-hidden="true"></i> Agenda</a>
        <a (click)="showBack()" href="javascript:void(0)" class="back" style="display:none;"><i class="fa fa-caret-left"
                aria-hidden="true"></i><i class="fa fa-caret-left" aria-hidden="true"></i> Agenda</a>


        <span *ngFor="let agenda of agendaObject || []; let i = index;" id="content-{{+i}}" attr.data-id='{{+i + 1}}'
            [ngStyle]="{'display': i == this.currentAgendaOnDisplay ? 'block' : 'none' }">
            <div *ngIf="agenda && agenda.AgendaGenerationPdf && agenda.AgendaGenerationPdf.length >= 1">
                <a href="javascript:void(0)" (click)="initiateUploadAgendaPdf(agenda)" id="openAttachment-{{i}}">
                    <i class="fa fa-paperclip" aria-hidden="true"></i> {{agenda.AgendaGenerationPdf.length}}
                </a>
            </div>
        </span> 
        

        <a (click)="showNext()" href="javascript:void(0)" class="next" >Agenda <i class="fa fa-caret-right"
                aria-hidden="true"></i><i class="fa fa-caret-right" aria-hidden="true"></i></a>
        <a href="javascript:void(0)" class="lastAgenda" style="display:none;">Agenda <i class="fa fa-caret-right"
                aria-hidden="true"></i><i class="fa fa-caret-right" aria-hidden="true"></i></a>
    </div>
</div>
<div class="agenda-details">
    <div *ngIf="currentAgenda && currentAgenda?.FinalUrl && showAgenda">
            <div id='pdf-div' style="width:100% !important; height: 50em;" class='pdf-view'></div>
    </div>
   
    <div class="content-holder" [hidden]="!hideAgenda">
        <div id='pdf-div-attach' style="width:100% !important; height: 50em;" class='pdf-view'></div>
    </div>
</div>
<div class="modal fade modal-size-medium" id="agendaPdfUploadDialogPSPFD" tabindex="-1" role="dialog"
    data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content" style="width: 60%;margin: auto;">
            <div class="modal-header">
                <h5 class="modal-title">
                    <i class="fa fa-upload"></i>
                    <span id="AgendaPdfUploadTitlePSPDF"></span>
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
                    <i class="fa fa-times"></i>
                </button>
            </div>
            <div class="modal-body" style="border:1px solid #ccc;">
                <div class="col-md-12">
                    <div class="row collapse1">
                        <table class="table table-hover compact cell-border nowrap stripe" style="cursor: pointer;">
                            <thead>
                                <tr>
                                    <td style="border-top:0px !important;"> <span
                                            style="padding:10px 15px;background: #d8ebeb;font-weight: 600;letter-spacing: 1px;display: inline-block;">
                                            {{agendaGenerationNumber}} </span> </td>
                                </tr>
                                <tr>
                                    <td style="border-top:0px !important;"> <a (click)="showCurrent()"
                                            href="javascript:void(0)" data-dismiss="modal"><span id="AgendaTitleOnPopup"
                                                style="font-weight: bold;"></span></a></td>
                                </tr>
                                <tr>
                                    <th>Filename</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let agenda of AgendaFile; let count=index">
                                    <td tabindex="1" style="width: 70%;">
                                        {{agenda.PdfName}}
                                    </td>
                                    <td>
                                        <button type="button" class="btn-sm btn btn-warning"
                                            (click)="downloadDocumentFile(agenda.DocumentManagementID,agenda.FileType)">
                                            <span title="View"
                                                *ngIf="agenda.FileType == 'PDF' || agenda.FileType == 'pdf' "
                                                class="fa fa-eye"></span>
                                            <span title="Download"
                                                *ngIf="agenda.FileType != 'PDF' && agenda.FileType != 'pdf' "
                                                class="fa fa-download"></span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Comment Section -->
<div class="comment-section" >
    <div class="comment-container">
        <h5 class="comment-heading">
            <i class="fa fa-comments" aria-hidden="true"></i> Comments
        </h5>
        
        <div class="comments-list" *ngIf="comments && comments.length > 0">
            <div class="comment-item" *ngFor="let comment of comments">
                <div class="comment-header" style="display: flex; justify-content: space-between; align-items: center;">
                    <div style="display: flex; align-items: center; flex: 1;">
                        <span class="comment-author">{{comment.author || 'Anonymous'}}</span>
                        <!-- Debug info -->
                        
                        <div class="comment-actions" *ngIf="canPostComment && isCommentAuthor(comment)" style="margin-left: 10px; display: flex !important; align-items: center; gap: 8px; visibility: visible !important; opacity: 1 !important;">
                            <button 
                                type="button" 
                                class="btn btn-sm btn-link text-primary" 
                                (click)="startEditComment(comment)"
                                *ngIf="editingCommentId !== comment._id"
                                title="Edit comment"
                                style="padding: 4px 8px; border: none; background: none; cursor: pointer; display: inline-flex !important; align-items: center; visibility: visible !important; opacity: 1 !important; min-width: auto !important; width: auto !important;">
                                <i class="fa fa-edit" aria-hidden="true"></i>
                            </button>
                            <button 
                                type="button" 
                                class="btn btn-sm btn-link text-danger" 
                                (click)="deleteComment(comment._id, comment)"
                                *ngIf="editingCommentId !== comment._id"
                                title="Delete comment"
                                style="padding: 4px 8px; border: none; background: none; cursor: pointer; display: inline-flex !important; align-items: center; visibility: visible !important; opacity: 1 !important; color: #dc3545 !important; min-width: auto !important; width: auto !important;">
                                <i class="fa fa-trash" aria-hidden="true" style="font-family: 'FontAwesome' !important; display: inline-block !important; visibility: visible !important; opacity: 1 !important;"></i>
                            </button>
                        </div>
                    </div>
                    <span class="comment-date" *ngIf="comment && comment.date" style="margin-left: auto;">{{comment.date | date:'short'}}</span>
                </div>
                <div class="comment-text" *ngIf="editingCommentId !== comment._id">{{comment.text}}</div>
                <div class="comment-edit-form" *ngIf="editingCommentId === comment._id">
                    <div class="form-group">
                        <textarea 
                            class="form-control comment-textarea" 
                            rows="3" 
                            [(ngModel)]="editCommentText"
                            name="editCommentText">
                        </textarea>
                    </div>
                    <div class="form-group">
                        <button 
                            type="button" 
                            class="btn btn-sm btn-primary" 
                            (click)="saveEditComment()">
                            <i class="fa fa-save" aria-hidden="true"></i> Save
                        </button>
                        <button 
                            type="button" 
                            class="btn btn-sm btn-secondary" 
                            (click)="cancelEditComment()"
                            style="margin-left: 5px;">
                            <i class="fa fa-times" aria-hidden="true"></i> Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="add-comment-form" *ngIf="canPostComment">
            <div class="form-group">
                <textarea 
                    class="form-control comment-textarea" 
                    rows="4" 
                    placeholder="Add your comment here..."
                    [(ngModel)]="newComment"
                    name="newComment">
                </textarea>
            </div>
            <div class="form-group">
                <button 
                    type="button" 
                    class="btn btn-primary btn-sm" 
                    (click)="addComment()"
                    [disabled]="isCommentDisabled()">
                    <i class="fa fa-paper-plane" aria-hidden="true"></i> Post Comment
                </button>
            </div>
        </div>
        <div class="comment-info-message" *ngIf="!canPostComment && comments && comments.length > 0">
            <p class="small" style="color: #495057;">
                <i class="fa fa-info-circle" aria-hidden="true"></i> 
                Only Board Members and KMP can post comments. You can view comments above.
            </p>
        </div>
        <div class="comment-info-message" *ngIf="!canPostComment && (!comments || comments.length === 0)">
            <p class="small" style="color: #495057;">
                <i class="fa fa-info-circle" aria-hidden="true"></i> 
                Only Board Members and KMP can post comments.
            </p>
        </div>
    </div>
</div>